import axios from "axios";
import Request from "../common/request";


// export const verificationCode = data =>
//   Request.get("/blade-auth/oauth/captcha", data);


// export const login2 = data => {
//   Request.post("/blade-auth/oauth/token", data)

// }
//登录
export const login = data => Request.post(`/webUserInfo/webuserinfo/login?${data}`);
//验证码登录
export const loginCaptcha = data => Request.post(`/webUserInfo/webuserinfo/login-captcha?${data}`);
//验证码判断
export const userVerificationCode = data => Request.post(`/webUserInfo/webuserinfo/verificationCode?${data}`);
//注册
export const register = data => Request.post('/webUserInfo/webuserinfo/submit', data);
//退出登录
export const logout = data => Request.post('/webUserInfo/webuserinfo/logout', data);
//获取短信验证码
export const sendCode = data => Request.post(`/blade-resource/sms/endpoint/send/code-message?${data}`);
//修改密码
export const updatePassword = data => Request.post(`/webUserInfo/webuserinfo/update-password?${data}`);
//我要咨询
export const sourceconsultingSave = data => Request.post(`/sourceConsulting/sourceconsulting/save`,data);

//委托发布列表
export const findAddressList = data => Request.get(`/entrustRoomInfo/entrustroominfo/list`,data);

//我的房源列表
export const myRoomlist = data => Request.get(`/roomInfo/roominfo/myRoomlist`,data);

//查询用户详细信息
export const webUserInfoDetail = data =>
Request.get("/webUserInfo/webuserinfo/detail", data)


// WEBPACK FOOTER //
// ./src/api/login.js